import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { useAuth } from './useAuth.tsx'
import { makeUrlConsignmentVoid } from './connectionData.tsx'

interface ApiParams {
  _id: string
  cause: string
  by: string
}
const apiUrl = makeUrlConsignmentVoid()

const useConsignmentVoid = () => {
  const [errorConsignmentVoid, setErrorConsignmentVoid] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const consignmentVoid = async (_id: string, cause: string) => {
    setLoading(true)

    try {
      const by = userData?.profile?._id ?? ''
      const apiParams: ApiParams = { _id, cause, by }
      await customPost(apiUrl, apiParams)

      setErrorConsignmentVoid(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorConsignmentVoid(err)
      } else {
        setErrorConsignmentVoid(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorConsignmentVoid, loading, consignmentVoid }
}
export default useConsignmentVoid
